import React, { useState, useEffect } from 'react';
import styles from '../styles/components/CookieBanner.module.css'; // Ajoute du style pour la bannière

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  return (
    isVisible && (
      <div className={styles.cookieBanner}>
        <div className={styles.cookieBannerContent}>
          <p>
            My website is using cookies to provide you a better experience. By browsing on my website, you accept the use of cookies according to my{' '}
            <a href="/politique-de-confidentialite" target="_blank" rel="noopener noreferrer">
              Confidentiality Policy
            </a>.
          </p>
          <button onClick={handleAccept}>Accept</button>
        </div>
      </div>
    )
  );
};

export default CookieBanner;
